module.exports = "/_next/static/images/first-home_faq-mobile-6c9bbcd67d5fe0dc010bf910ae2f5412.svg";